const CAPTCHA_PICTURES_X = 4
const CAPTCHA_PICTURES_Y = 4
const PICTURE_SIZE = 12
const P = 8 // pixel size

export default (drawData: string, modelName: string) => ({
  drawData,
  captchas: null as null | HTMLElement,
  init() {
    this.captchas = this.$root.querySelector('#captchas')
    this.createCaptchas()

    this.$root.closest('form').addEventListener('ajax:error', async ({ detail }) => {
      try {
        // only fetch new captcha if invalid
        if (detail?.[0]?.includes('Captcha')) {
          const response = await fetch('/captcha')
          const data = await response.json()

          this.drawData = data.draw_data
          this.$root.querySelector('#captcha-question').textContent = data.question
          this.$root.querySelector('#captcha-seed').value = data.seed
          this.createCaptchas()
        }
      } catch (error) {
        flash('alert', I18n.unknown_error)
      }
    })
  },

  createCaptchas() {
    this.captchas?.replaceChildren()

    for (let ny = 0; ny < CAPTCHA_PICTURES_Y; ny++) {
      for (let nx = 0; nx < CAPTCHA_PICTURES_X; nx++) {
        const label = document.createElement('label')
        label.classList.add('captcha')
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')!

        const index = ny * CAPTCHA_PICTURES_X + nx

        const checkbox = document.createElement('input')
        checkbox.setAttribute('type', 'checkbox')
        checkbox.setAttribute('name', `${modelName}[captcha${index}]`)

        canvas.width = PICTURE_SIZE * P
        canvas.height = PICTURE_SIZE * P

        ctx.fillStyle = '#000'
        ctx.fillRect(0, 0, canvas.width, canvas.height)

        for (let x = 0; x < PICTURE_SIZE; x++) {
          for (let y = 0; y < PICTURE_SIZE; y++) {
            const color =
              this.drawData[(ny * CAPTCHA_PICTURES_X + nx) * PICTURE_SIZE * PICTURE_SIZE + (y * PICTURE_SIZE + x)]
            ctx.fillStyle = '#212528' // empty pixel
            if (color == '1') ctx.fillStyle = '#f1482b' // red pixel
            if (color == '2') ctx.fillStyle = '#fff' // white pixel
            ctx.fillRect(x * P, y * P, P, P)
          }
        }

        label.appendChild(checkbox)
        label.appendChild(canvas)
        this.captchas?.appendChild(label)
      }
    }
  },
})
